module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione4 b.37c5b31b.svg";